<template>
  <section class="popups" v-if="startsCount <= 1">
    <div class="popup links-popup">
      <div class="popup-links--wrapper">
        <img src="/img/popup-close.svg" class="close-popup" v-on:click="closePopup($event)" alt="">
        <h2>Через приложение будет быстрее и удобнее</h2>
        <div class="popup-buttons">
          <button v-on:click="getAppLink($event)">Открыть в приложении</button>
          <span class="close-popup--link" v-on:click="closePopup($event)">Продолжить в web-версии</span>
        </div>
      </div>
    </div>
  </section>
</template>

<style>
.popups {
  position: fixed;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  z-index: 99999999;
}

.popups .popup {
  position: absolute;
  top: calc(50% - 310px);
  left: calc(50% - 161px);
  width: 320px;
  height: 623px;
  background: linear-gradient(180deg, #A7C3FF 0%, #C3D5FB 54.17%, #A7C3FF 100%);
  box-shadow: 0px 0px 40px rgba(0, 0, 0, 0.5);
  border-radius: 32px;
}

.popup-links--wrapper {
  overflow: hidden;
  height: 100%;
  background: url(/img/popup/icons.png) no-repeat center 60%
  , url(/img/popup/balloons.png) no-repeat 10% 27%
  , url(/img/popup/phone.png) no-repeat center;
}

.popup-links--wrapper h2 {
  color: #fff;
  font-family: 'Avenir Next Cyr';
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  padding: 1rem;
  margin-top: 40px;
  text-align: center;
}

.close-popup--link {
  color: #fff;
  cursor: pointer;
  font-family: 'Avenir Next Cyr';
  font-style: normal;
  font-weight: 450;
  font-size: 14px;
  padding: 1rem;
  text-align: center;
  margin-top: 40px;
}

.links-popup button {
  width: 100%;
  text-align: center;
  padding: 1rem;
  background: radial-gradient(42.63% 42.63% at 42.4% 64.39%, #FEB64D 0%, #FF9500 100%);
  backdrop-filter: blur(81.6395px);
  border: none;
  border-radius: 32px;
  color: #fff;
  margin-bottom: 1rem;
  font-family: "Avenir Next Cyr";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  letter-spacing: 0.013em;
}

.popup-buttons {
  position: absolute;
  bottom: 1rem;
  text-align: center;
  padding: 1rem;
}

.popup-buttons:after {
  content: "";
  position: absolute;
  top: 0px;
  width: 100px;
  height: 10px;
  background: radial-gradient(57.22% 57.11% at 49.65% 66.17%, #ADADAD 1%, #C0C0C0 7%, #D7D7D7 16%, #E9E9E9 28%, #F6F6F6 41%, #FDFDFD 59%, #FFFFFF 100%);
  background-blend-mode: multiply;
  mix-blend-mode: multiply;
  opacity: 0.62;
  left: calc(50% - 50px);
}

@media screen and (max-width: 320px) {
  .popups .popup {
    width: 300px;
    left: calc(50% - 150px);
  }

  .popup-buttons:after {
    background: transparent;
  }
}

@media screen and (max-height: 650px) {
  .popups .popup {
    height: 500px;
    top: calc(50% - 250px);
  }

  .popup-links--wrapper {
    overflow: hidden;
    height: 100%;
    background: url(/img/popup/phone.png) no-repeat center;
    background-size: 50%;
  }

  .popup-buttons:after {
    background: transparent;
  }
}

@media screen and (max-height: 530px) {
  .popups .popup {
    height: 300px;
    top: calc(50% - 150px);
  }

  .popup-links--wrapper {
    overflow: hidden;
    height: 100%;
    background: url(/img/popup/phone.png) no-repeat center;
    background-size: 40%;
  }

  .popup-links--wrapper {
    background: transparent;
  }
}
</style>

<script lang="ts">
  import $ from 'jquery';

  export default {
    name: "Popup",
    data() {
      return {

      };
    },
    mounted: function() {
      this.$store.dispatch('startsCount');
    },
    computed: {
      startsCount() {
        return this.$store.getters.startsCount;
      },
    },
    
    methods: {
      closePopup(event) {
        event.preventDefault();

        $('.popups').hide();
        document.location.reload();
      },
      getAppLink() {
        document.location.href = 'https://www.myclient.me/';
      }
    }
  }
</script>
